import {
  Payout,
  PayoutTransferPurpose,
  PayoutTransferStatus
} from "@wingspanhq/wingspan-api-sdk";

export const getFailedStatusCount = (payout: Payout) => {
  const walletTransfer = payout.transfers.find(
    transfer => transfer.purpose === PayoutTransferPurpose.WALLET_REMAINDER
  );
  const disbursementTransfers = payout.transfers.filter(
    transfer => transfer.purpose === PayoutTransferPurpose.DISBURSEMENT
  );

  const allTransfers = walletTransfer
    ? [walletTransfer, ...disbursementTransfers]
    : disbursementTransfers.filter(
        transfer => transfer.fundsMovementId !== undefined
      );

  const allErrorTransfers = allTransfers.filter(
    transfer => transfer.status === PayoutTransferStatus.FAILED
  );

  return {
    errorsLength: allErrorTransfers.length,
    transfersLength: allTransfers.length
  };
};
